import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function OnToOffDone(props) {
  const { onClickAction } = props;
  const { t } = useTranslation();

  useEffect(() => {
    sendTrackingInfo('Mis avisos', `Finalizar Aviso-Exito`);
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.OnToOffDone.title')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { OnToOffDone };
